@if (currentRoute | async; as route) {
  <mat-sidenav-container class="layout-home-container">
    @if (confService.conf.hasBP2) {
      <mat-sidenav #searchSidenav class="search-sidenav">
        @switch (route) {
          @case (homeRoute.ONLINE) {
            <o-search-products [searchSidenav]="searchSidenav"> </o-search-products>
          }
          @case (homeRoute.CONTRACTS) {
            <o-search-contracts [searchSidenav]="searchSidenav"> </o-search-contracts>
          }
        }
      </mat-sidenav>
    }
    <mat-sidenav #settingsSidenav class="settings-sidenav" position="end">
      <o-settings-home [settingsSidenav]="settingsSidenav"></o-settings-home>
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-toolbar oSticky class="ori-elevation-z4 home-header" [class.degraded]="isDegradedState | async">
        <div class="left-side">
          @if (confService.conf.hasBP2 && (route === homeRoute.ONLINE || route === homeRoute.CONTRACTS)) {
            <button
              mat-icon-button
              [disabled]="isDegradedState | async"
              class="search-button"
              (click)="searchSidenav.toggle()">
              <mat-icon svgIcon="menu-burger"></mat-icon>
            </button>
          }
          <a id="orion-logo" [routerLink]="['/home/tabs/local']" [ngClass]="{ disable: route === homeRoute.REPLICATE }">
            <img src="./assets/img/logo_ORION2.png" alt="ORION2 logo" />
          </a>
          @if (titleService.headerTitle) {
            <h3 class="header-title">{{ titleService.headerTitle | translate }}</h3>
          }
        </div>
        <div class="right-side">
          <button mat-icon-button class="news-button" (click)="openNewsModal()">
            <mat-icon
              aria-hidden="false"
              matBadgeSize="medium"
              [matBadge]="badgeNumber | async"
              [matBadgeHidden]="(badgeNumber | async) === 0"
              matBadgeColor="accent"
              svgIcon="bell">
            </mat-icon>
          </button>
          <button
            mat-icon-button
            class="setting-button"
            (click)="settingsSidenav.toggle()"
            [ngClass]="{ opened: settingsSidenav?.opened }">
            <mat-icon svgIcon="menu-kebab"></mat-icon>
          </button>
        </div>
      </mat-toolbar>
      @if (isDegradedState | async) {
        <div oSticky class="degraded-header deteriorate-warning">
          {{ "degradation.bp2.disclaimer" | translate }}
        </div>
      }
      <router-outlet (activate)="scrollTop()"></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
